import React from 'react'
import Sidebar from '../components/Sidebar'
import Header from '../components/Header'
import StudentList from './contents/StudentList'
import ManageSubjects from './contents/ManageSubjects'
import ManageTopics from './contents/ManageTopics'
import ManageBatch from './contents/ManageBatch'
import ManageSubTopic from './contents/ManageSubTopic'
import ManageMentors from './contents/ManageMentors'
import AddStudent from './contents/AddStudent'
import AddSubjects from './contents/AddSubjects'
import AddBatch from './contents/AddBatch'
import ViewBatch from './contents/ViewBatch'
import {
	CModal,
	CModalHeader,
	CModalTitle,
	CModalBody,
	CModalFooter,
	CButton,
	CSpinner,
	CRow,
	CCol,
	CFormInput,
} from '@coreui/react';
import ViewSubject from './contents/ViewSubject'
import AddTopic from './contents/AddTopic'
import ViewTopic from './contents/ViewTopic'
import AddSubTopic from './contents/AddSubTopic'
import ViewSubTopic from './contents/ViewSubTopic'
import AddMentor from './contents/AddMentor'
import ViewMentor from './contents/ViewMentor'
import ViewStudent from './contents/ViewStudent'
import AppButton from 'src/components/AppButton'
import { isStringEmpty } from 'src/util/StringUtil'
import ServerConnector from 'src/ServerConnector'
import SummaryReport from './reports/SummaryReport'
import TopMentorsReport from './reports/TopMentorsReport'
import MentorSummaryReport from './reports/MentorSummaryReport'
import TopStudentsReport from './reports/TopStudentsReport'
import DoubtsSummaryReport from './reports/DoubtsSummaryReport'
import MessageGroupList from './contents/MessageGroupList'
import AddMessageGroup from './contents/AddMessageGroup'
import ViewMessageGroup from './contents/ViewMessageGroup'
import MessagesList from './contents/MessagesList'
import SendMessage from './contents/SendMessage'
import ManageChatGroup from './contents/ManageChatGroup'
import AddChatGroup from './contents/AddChatGroup'
import ViewChatGroup from './contents/ViewChatGroup'

const defaultSelectedMenuId = "manage_subjects_menu"
const defaultSelectedPageId = "manage_subjects"

export default class Admin extends React.Component {

	constructor(props) {
		super(props);

		let userName = localStorage.getItem("user_id");
		let password = localStorage.getItem("password");

		if (!userName || userName.length == 0 ||
			!password || password.length == 0) {

			this.props.history.push("/");
		}

		this.state = {
			selected_menu: defaultSelectedMenuId,
			page_id: defaultSelectedPageId,
			page_data: null,
			pageSpinnerVisible: false,
			confirmation: {
				visible: false,
				header: "",
				message: "",
				positiveButtonLabel: "Yes",
				negativeButtonLabel: "No",
				successCallBack: null,
				data: null
			},
			alert: {
				visible: false,
				header: "",
				message: "",
				buttonLabel: "Ok",
				callBack: null,
				data: null
			},
			changepwdpopup: {
				visible: false,
				isLoadingSubmit: false,
				old_password: "",
				old_passworderr: "",
				new_password: "",
				new_passworderr: "",
				confirm_password: "",
				confirm_passworderr: ""
			},
		}
	}

	onMenuClick(menuId, pageId) {

		this.setState({
			selected_menu: menuId
		});
		this.navigate(pageId, null);
	}

	navigate(pageId, data) {

		this.setState({
			page_id: pageId,
			page_data: data
		});
	}

	addnlActions(clickType) {

		if (clickType == "LOGOUT") {

			this.logout();
		}
		else if (clickType == "CHANGE_PWD") {

			this.changePwdPopup();
		}
	}

	logout() {

		localStorage.setItem("user_id", "");
		localStorage.setItem("password", "");
		this.props.history.push("/");
	}

	showConfirmation(header, msg, pBtnName, nBtnName, data, successCallBack) {

		let confirmation = this.state.confirmation;
		confirmation["visible"] = true;
		confirmation["header"] = header;
		confirmation["message"] = msg;
		confirmation["positiveButtonLabel"] = pBtnName ? pBtnName : "Yes";
		confirmation["negativeButtonLabel"] = nBtnName ? nBtnName : "No";
		confirmation["successCallBack"] = successCallBack;
		confirmation["data"] = data;
		this.setState({
			confirmation: confirmation
		});
	}

	showAlert(header, msg, btnName, data, callBack) {

		let alert = this.state.alert;
		alert["visible"] = true;
		alert["header"] = header;
		alert["message"] = msg;
		alert["buttonLabel"] = btnName ? btnName : "Ok";
		alert["callBack"] = callBack;
		alert["data"] = data;
		this.setState({
			alert: alert
		});
	}

	closeConfirmationPopup() {

		let confirmation = this.state.confirmation;
		confirmation["visible"] = false;
		this.setState({
			confirmation: confirmation
		});
	}

	closeAlertPopup() {

		let alert = this.state.alert;
		alert["visible"] = false;
		this.setState({
			alert: alert
		});
	}

	showPageSpinner(isShow) {

		this.setState({
			pageSpinnerVisible: isShow
		});
	}

	changePwdPopup() {

		let changepwdpopup = this.state.changepwdpopup;
		changepwdpopup["visible"] = true;
		changepwdpopup["old_password"] = "";
		changepwdpopup["old_passworderr"] = "";
		changepwdpopup["new_password"] = "";
		changepwdpopup["new_passworderr"] = "";
		changepwdpopup["confirm_password"] = "";
		changepwdpopup["confirm_passworderr"] = "";

		this.setState({
			changepwdpopup: changepwdpopup
		});
	}

	closeChangePwdPopup() {

		let changepwdpopup = this.state.changepwdpopup;
		changepwdpopup["visible"] = false;

		this.setState({
			changepwdpopup: changepwdpopup
		});
	}

	updatePasswordInput(field, event) {

		let changepwdpopup = this.state.changepwdpopup;
		changepwdpopup[field] = event.target.value;
		changepwdpopup[field + "err"] = "";

		this.setState({
			changepwdpopup: changepwdpopup
		});
	}

	validateChangePassword() {

		var isValid = true;
		let changepwdpopup = this.state.changepwdpopup;

		if (isStringEmpty(changepwdpopup.old_password)) {
			changepwdpopup["old_passworderr"] = "Required";
			isValid = false;
		}

		if (isStringEmpty(changepwdpopup.new_password)) {
			changepwdpopup["new_passworderr"] = "Required";
			isValid = false;
		}

		if (isStringEmpty(changepwdpopup.confirm_password)) {
			changepwdpopup["confirm_passworderr"] = "Required";
			isValid = false;
		}

		if (isValid && changepwdpopup.new_password != changepwdpopup.confirm_password) {
			changepwdpopup["confirm_passworderr"] = "Confirm password is not matching with new password";
			isValid = false;
		}

		if (isValid) {

			this.submitChangePassword();
		}
		else {

			this.setState({
				changepwdpopup: changepwdpopup
			});
		}
	}

	submitChangePassword() {

		let changepwdpopup = this.state.changepwdpopup;
		changepwdpopup["isLoadingSubmit"] = true;
		this.setState({
			changepwdpopup: changepwdpopup
		});

		let connector = new ServerConnector();
		let dataMap = {
			_action_code: "CHANGE_PASSWORD",
			old_password: this.state.changepwdpopup.old_password,
			new_password: this.state.changepwdpopup.new_password
		}
		connector.postData(dataMap, (data) => { // success

			this.closeChangePwdPopup();
			localStorage.setItem("password", this.state.changepwdpopup.new_password);
			this.showAlert("Success", data.msg, "Ok", null, null);

		}, (err_cd, msg, data) => { // failure

			var isHandled = false;
			changepwdpopup["isLoadingSubmit"] = false;

			if (data && data.data) {

				for (let key in data.data) {

					changepwdpopup[key + "err"] = data.data[key];
				}
				isHandled = true;
			}

			this.setState({
				changepwdpopup: changepwdpopup
			});

			if (!isHandled) {

				this.showAlert("Error", msg, "Ok", null, null);
			}
		});
	}

	render() {

		const pageItem = pageList[this.state.page_id];
		const Content = pageItem.page;

		return (
			<div>
				{
					this.state.pageSpinnerVisible ?
						<div className="mainPageSpinner">
							<CSpinner variant="grow" className="mainPageSpinnerLeft" />
							<CSpinner variant="grow" className="mainPageSpinnerCenter" />
							<CSpinner variant="grow" className="mainPageSpinnerRight" />
						</div>
						: null
				}

				<Sidebar
					selected_menu={this.state.selected_menu}
					onMenuClick={(menuId, pageId) => this.onMenuClick(menuId, pageId)}
					addnlActions={(clickType) => { this.addnlActions(clickType) }} />
				<div className="wrapper d-flex flex-column min-vh-100 bg-light">
					<Header addnlActions={(clickType) => { this.addnlActions(clickType) }} />
					<div className="body flex-grow-1 px-3 contentSection">
						<Content
							page_data={this.state.page_data}
							page_name={pageItem.pageName}
							navigate={(pageId, data) => this.navigate(pageId, data)}
							showConfirmation={(header, msg, pBtnName, nBtnName, data, successCallBack) => this.showConfirmation(header, msg, pBtnName, nBtnName, data, successCallBack)}
							showAlert={(header, msg, btnName, data, callBack) => this.showAlert(header, msg, btnName, data, callBack)}
							showPageSpinner={(isShow) => this.showPageSpinner(isShow)} />
					</div>
				</div>

				<CModal
					visible={this.state.confirmation.visible}
					onClose={() => { this.closeConfirmationPopup() }} >
					<CModalHeader>
						<CModalTitle>{this.state.confirmation.header}</CModalTitle>
					</CModalHeader>
					<CModalBody>{this.state.confirmation.message}</CModalBody>
					<CModalFooter>
						<CButton
							color="secondary"
							onClick={() => { this.closeConfirmationPopup() }}>
							{this.state.confirmation.negativeButtonLabel}
						</CButton>
						<CButton
							color="primary"
							onClick={() => {
								this.closeConfirmationPopup();
								this.state.confirmation.successCallBack ? this.state.confirmation.successCallBack(this.state.confirmation.data) : null;
							}}>
							{this.state.confirmation.positiveButtonLabel}
						</CButton>
					</CModalFooter>
				</CModal>

				<CModal
					visible={this.state.alert.visible}
					onClose={() => { this.closeAlertPopup() }} >
					<CModalHeader>
						<CModalTitle>{this.state.alert.header}</CModalTitle>
					</CModalHeader>
					<CModalBody>{this.state.alert.message}</CModalBody>
					<CModalFooter>
						<CButton
							color="primary"
							onClick={() => {
								if (this.state.alert.callBack) {
									this.state.alert.callBack(this.state.alert.data);
								}
								this.closeAlertPopup();
							}}>
							{this.state.alert.buttonLabel}
						</CButton>
					</CModalFooter>
				</CModal>

				<CModal
					visible={this.state.changepwdpopup.visible}
					onClose={() => { this.closeChangePwdPopup() }} >
					<CModalHeader>
						<CModalTitle>Change Password</CModalTitle>
					</CModalHeader>
					<CModalBody>
						<CRow>
							<CCol md="12">
								<CFormInput type="password" maxLength="64"
									onChange={(event) => { this.updatePasswordInput("old_password", event) }}
									value={this.state.changepwdpopup.old_password}
									placeholder="Enter Old Password" />
								<div className="inputError">
									{this.state.changepwdpopup.old_passworderr}
								</div>
							</CCol>
							<CCol md="12" className="mt-3">
								<CFormInput type="password" maxLength="64"
									onChange={(event) => { this.updatePasswordInput("new_password", event) }}
									value={this.state.changepwdpopup.new_password}
									placeholder="Enter New Password" />
								<div className="inputError">
									{this.state.changepwdpopup.new_passworderr}
								</div>
							</CCol>
							<CCol md="12" className="mt-3">
								<CFormInput type="password" maxLength="64"
									onChange={(event) => { this.updatePasswordInput("confirm_password", event) }}
									value={this.state.changepwdpopup.confirm_password}
									placeholder="Confirm New Password" />
								<div className="inputError">
									{this.state.changepwdpopup.confirm_passworderr}
								</div>
							</CCol>
						</CRow>
					</CModalBody>
					<CModalFooter>
						<AppButton
							size="sm"
							name="Cancel"
							isLoading={false}
							onClick={() => { this.closeChangePwdPopup(); }} />
						<AppButton
							size="sm"
							name="Submit"
							color="primary"
							isLoading={this.state.changepwdpopup.isLoadingSubmit}
							onClick={() => { this.validateChangePassword(); }} />
					</CModalFooter>
				</CModal>
			</div>
		);
	}
}

const pageList = {
	student_list: {
		pageName: "Student List",
		page: StudentList
	},
	manage_batch: {
		pageName: "Manage Batch",
		page: ManageBatch
	},
	manage_subjects: {
		pageName: "Subjects",
		page: ManageSubjects
	},
	manage_topics: {
		pageName: "Manage Topics",
		page: ManageTopics
	},
	manage_sub_topics: {
		pageName: "Manage Sub Topics",
		page: ManageSubTopic
	},
	manage_mentors: {
		pageName: "Manage Mentors",
		page: ManageMentors
	},
	add_student: {
		pageName: "Student",
		page: AddStudent
	},
	view_student: {
		pageName: "View Student Details",
		page: ViewStudent
	},
	add_subject: {
		pageName: "Subject",
		page: AddSubjects
	},
	add_batch: {
		pageName: "Batch",
		page: AddBatch
	},
	view_batch: {
		pageName: "View Batch Details",
		page: ViewBatch
	},
	view_subject: {
		pageName: "View Subject Details",
		page: ViewSubject
	},
	add_topic: {
		pageName: "Topic",
		page: AddTopic
	},
	view_topic: {
		pageName: "View Topic Details",
		page: ViewTopic
	},
	add_subtopic: {
		pageName: "Sub Topic",
		page: AddSubTopic
	},
	view_subtopic: {
		pageName: "View Sub Topic Details",
		page: ViewSubTopic
	},
	add_mentor: {
		pageName: "Mentor",
		page: AddMentor
	},
	view_mentor: {
		pageName: "View Mentor Details",
		page: ViewMentor
	},
	summary_report: {
		pageName: "Summary Report",
		page: SummaryReport
	},
	top_mentors_report: {
		pageName: "Top 10 Performing Mentors",
		page: TopMentorsReport
	},
	mentors_summary_report: {
		pageName: "All Mentors Summary",
		page: MentorSummaryReport
	},
	doubts_summary_report: {
		pageName: "Doubts Summary",
		page: DoubtsSummaryReport
	},
	top_students_report: {
		pageName: "Top 10 Performing Students",
		page: TopStudentsReport
	},
	student_sets: {
		pageName: "Message Groups",
		page: MessageGroupList
	},
	add_message_group: {
		pageName: "Message Group",
		page: AddMessageGroup
	},
	view_message_group: {
		pageName: "View Message Group",
		page: ViewMessageGroup
	},
	messages_list: {
		pageName: "Messages",
		page: MessagesList
	},
	send_message: {
		pageName: "Send Message",
		page: SendMessage
	},
	manage_chat_group: {
		pageName: "Manage Chat Group",
		page: ManageChatGroup
	},
	add_chat_group: {
		pageName: "Chat Group",
		page: AddChatGroup
	},
	view_chat_group: {
		pageName: "View Chat Group Details",
		page: ViewChatGroup
	},
};
